import React from 'react';
import PropTypes from 'prop-types';
import Form from '../containers/Form';
import SimpleHeader from '../../../headers/simpleHeader';
import { trimFunction } from '../../../../common/trimData';
import { t } from '../../../../../modules/infra/i18n';

const Add = ({ onSubmit, baseUrl }) => (
  <div>
    <SimpleHeader heading={t('customers:marketing_leads.add_channel_heading')} />
    <Form onSubmit={trimFunction(onSubmit)} baseUrl={baseUrl} />
  </div>
);
Add.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  baseUrl: PropTypes.string.isRequired,
};

export default Add;
